import { defineComponent as _defineComponent } from 'vue'
import { Ref, computed, onBeforeMount, ref } from 'vue';
import { AxiosError } from 'axios';
import { getEmailConfirmation, updateEmail } from '@/api/user';
import { BModal } from 'bootstrap-vue';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailUpdateDialog',
  props: {
    value: { type: Boolean },
    email: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value: boolean;
    email?: string;
};





const savingEmail = ref(false);
const emailChanged = ref(false);
const newEmail: Ref<string | null> = ref(null);
const currentPassword: Ref<string | null> = ref(null);
const emailErrorMessage: Ref<string | null> = ref(null);

const pendingEmail: Ref<string | null> = ref(null);
const invalidPassword = ref(false);
const invalidEmail = ref(false);

const isVisible = computed({
    get(): boolean {
        return props.value;
    },
    set(value: boolean) {
        emailErrorMessage.value = null;
        emailChanged.value = false;
        checkPendingConfirmation();
        emit('input', value);
    }
});

const emailsAreTheSame = computed(() => {
    return props.email === newEmail.value;
});

onBeforeMount(() => {
    checkPendingConfirmation();
});

const checkPendingConfirmation = async () => {
    const pendingConfirmation = await getEmailConfirmation();
    if (pendingConfirmation.PendingConfirmation && pendingConfirmation.NewEmail) {
        pendingEmail.value = pendingConfirmation.NewEmail;
    } else {
        pendingEmail.value = null;
    }
};

const changeEmailAddress = async () => {
    try {
        savingEmail.value = true;
        emailErrorMessage.value = null;
        invalidPassword.value = false;
        invalidEmail.value = false;

        if (currentPassword.value && newEmail.value) {
            await updateEmail(currentPassword.value, newEmail.value);
        }
        emailChanged.value = true;
    } catch (error) {
        const axiosError = error as AxiosError;
        if (axiosError.response?.status === 400) {
            if (axiosError.response.data.Message) {
                if (axiosError.response.data.Message === 'Invalid Password') {
                    invalidPassword.value = true;
                } else if (axiosError.response.data.Message === 'Email already in use') {
                    invalidEmail.value = true;
                } else {
                    emailErrorMessage.value = axiosError.response.data.Message;
                }
            }
        } else {
            emailErrorMessage.value = 'Fatal error';
            window.rumReportError(axiosError);
        }
    } finally {
        savingEmail.value = false;
    }
};

return { __sfc: true,props, emit, savingEmail, emailChanged, newEmail, currentPassword, emailErrorMessage, pendingEmail, invalidPassword, invalidEmail, isVisible, emailsAreTheSame, checkPendingConfirmation, changeEmailAddress, BModal, LoaderBtn, ValidationProvider, ValidationObserver }
}

})